import React from "react";
import FashionTillShell from "./FashionTillShell";
import FashionDenomGrid from "./FashionDenomGrid";
import { formatTillMoney, tillAmountValue } from "./tillFormat";

// Rows of the expected-cash breakdown; `flag` is the "Close Till Denominations"
// till-access-meta key that hides the row (same rules as the classic screen).
const ROWS = [
  { key: "opening", label: "Opening cash", flag: "OpeningAmount" },
  { key: "sales", label: "Cash sales", flag: "SalesAmount" },
  { key: "refunds", label: "Cash refunds", flag: "SalesReturnAmount", minus: true },
  { key: "cashIn", label: "Cash in", flag: "CashIn" },
  { key: "cashOut", label: "Cash out", flag: "CashOut", minus: true },
  { key: "pettyCashIn", label: "Petty cash in", flag: "PettyCashIn" },
  { key: "pettyCashOut", label: "Petty cash out", flag: "PettyCashOut", minus: true },
];

// Board close-count: step 1 of close till.
const FashionCloseCount = ({
  outlet,
  till,
  day,
  currency,
  denominations,
  totalAmount,
  amounts = {},
  expectedAmount,
  meta: flags,
  onFieldInput,
  onFieldOut,
  onFieldButton,
  onNext,
  onBack,
  loading,
  confirmBtnRef,
  cancelBtnRef,
}) => {
  const shown = (flag) => !flags || flags[flag] === "Y";
  const counted = tillAmountValue(totalAmount);
  const expected = tillAmountValue(expectedAmount);
  const diff = Math.round((counted - expected) * 100) / 100;
  const meta = [till, outlet, day].filter(Boolean).join(" · ");
  return (
    <FashionTillShell title="Close till" meta={meta} onBack={onBack} step={1} testId="fashion-close-count">
      <section className="ftill-main">
        <div>
          <h1 className="ftill-h1">Count the cash in the drawer</h1>
          <p className="ftill-sub">Count before you look at the expected amount. It keeps the count honest.</p>
        </div>
        <FashionDenomGrid denominations={denominations} currency={currency} onFieldInput={onFieldInput} onFieldOut={onFieldOut} onFieldButton={onFieldButton} />
      </section>
      <aside className="ftill-side">
        <div className="ftill-total">
          <span className="ftill-total__label">Cash counted</span>
          <b className="ftill-total__value">{formatTillMoney(counted, currency)}</b>
        </div>
        <div className="ftill-rows">
          {ROWS.filter((row) => shown(row.flag)).map((row) => {
            const value = Math.abs(tillAmountValue(amounts[row.key]));
            return (
              <div className="ftill-row" key={row.key}>
                <span>{row.label}</span>
                <b>{row.minus && value > 0 ? `−${formatTillMoney(value, currency)}` : formatTillMoney(value, currency)}</b>
              </div>
            );
          })}
          {shown("ExpectedCash") ? (
            <>
              <div className="ftill-row ftill-row--total">
                <span>Expected in drawer</span>
                <b>{formatTillMoney(expected, currency)}</b>
              </div>
              <div className="ftill-row">
                <span>{diff < 0 ? "Short" : diff > 0 ? "Over" : "Difference"}</span>
                <span className={`ftill-pill ftill-pill--${diff === 0 ? "ok" : diff < 0 ? "bad" : "warn"}`}>
                  {diff === 0 ? "Matches" : formatTillMoney(Math.abs(diff), currency)}
                </span>
              </div>
            </>
          ) : null}
        </div>
        <div className="ftill-grow" />
        <div className="ftill-actions">
          <button type="button" ref={cancelBtnRef} className="ftill-btn ftill-btn--secondary" onClick={onBack}>
            Back
          </button>
          <button type="button" ref={confirmBtnRef} className="ftill-btn ftill-btn--primary" onClick={onNext} disabled={loading}>
            {loading ? "Processing..." : "Next: check payments"}
          </button>
        </div>
      </aside>
    </FashionTillShell>
  );
};

export default FashionCloseCount;
